const TURBO_RENDER_DELAY_MS = 100
const TURBO_SUBMIT_DELAY_MS = 200

export default function createStripeAutoInit(
  initializeFunc,
  { checkout, listenToTurbo = false } = {},
) {
  let initializedElement = listenToTurbo ? null : undefined

  function autoInitialize() {
    const checkoutEl = document.getElementById('checkout')

    // Every checkout script is bundled onto every page, and Stripe allows one
    // embedded checkout per page, so each starts only where the container names it.
    if (checkoutEl?.dataset.stripeCheckout !== checkout) return

    const isEmpty = checkoutEl && !checkoutEl.children.length && !checkoutEl.textContent.trim()
    const isNewElement = !listenToTurbo || checkoutEl !== initializedElement

    if (isEmpty && isNewElement) {
      if (listenToTurbo) {
        initializedElement = checkoutEl
      }
      initializeFunc()
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitialize)
  } else {
    autoInitialize()
  }

  if (listenToTurbo) {
    document.addEventListener('turbo:before-stream-render', () => {
      initializedElement = null
    })

    document.addEventListener('turbo:render', () => {
      setTimeout(autoInitialize, TURBO_RENDER_DELAY_MS)
    })

    document.addEventListener('turbo:frame-render', () => {
      setTimeout(autoInitialize, TURBO_RENDER_DELAY_MS)
    })

    document.addEventListener('turbo:submit-end', () => {
      setTimeout(autoInitialize, TURBO_SUBMIT_DELAY_MS)
    })
  }
}
